/* src/app/forms/contractpref-main/contractpref-main.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.content {
  padding: 5px;
  height: 100%;
  display: flex;
}
/*# sourceMappingURL=contractpref-main.component.css.map */
